export const getURLWithoutQueryParams = (url: string): string => {
  const [urlWithoutQueryParams] = url.split('?');
  return urlWithoutQueryParams;
};

export const getFilenameFromUrl = (url: string | undefined): string => {
  if (!url) return '';
  const { pathname } = new URL(url);
  const filename = pathname.split('/').pop();
  return filename ? decodeURI(filename) : pathname;
};
